import {
  Alert,
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormInputItem, FormPasswordItem } from "../../components/formInput";
import {
  CreateDataOnServer,
  GetDataFromServer,
  GetDataListFromServer,
  UpdateDateOnServer,
} from "../../lib/api";
import {
  AVATAR_LIST,
  BANK_TYPE,
  USER_CREATE,
  USER_UPDATE,
} from "../../lib/config";
import { useSelector } from "react-redux";
import {
  KeyOutlined,
  UserOutlined,
  BankOutlined,
  VerifiedOutlined,
  FieldNumberOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import toast from "react-hot-toast";
import AvatarForm from "../avatar/form";
import { QUERY_AVATAR } from "../../lib/query_obj";
import { queryHandler } from "../../lib/global_functions";
import dayjs from "dayjs";
import moment from "moment-timezone";

const { Text } = Typography;
export default function UserForm({ closeDrawer, edit }) {
  const { access_token, csrf_token, ui_size } = useSelector(
    (state) => state.user
  );
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(false);
  const [selectedBankType, setSelectedBankType] = useState("");
  const [passwordError, setPasswordError] = useState(
    "Password must be at least 8 characters"
  );
  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });
  async function submitHandler(values) {
    setLoading(true);

    const formattedVal = {
      ...values,
      dob: moment
      .tz(values.dob.format("YYYY-MM-DD"), "Asia/Yangon")
      .utc()
      .format(),
    };

    console.log("formattedVal...", formattedVal);

    const apiCall = edit
      ? UpdateDateOnServer(
          USER_UPDATE,  
          edit.id,
          formattedVal,
          access_token,
          csrf_token
        )
      : CreateDataOnServer(USER_CREATE, values, access_token, csrf_token);

    apiCall
      .then(() => {
        toast.success(
          edit ? "Updated user successfully" : "Created user successfully"
        );
        setLoading(false);
        closeDrawer(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  }

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.reject();
    }
    if (value.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      return Promise.reject(
        new Error("Password must be at least 8 characters")
      );
    }
    setPasswordError("");
    return Promise.resolve();
  };

  async function getDataList() {
    await GetDataFromServer(BANK_TYPE, access_token)
      .then(({ data: { data: res, total } }) => {
        setBankList(res);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function getAvatarDataList(page_number, per_page) {
    await GetDataListFromServer(
      AVATAR_LIST,
      queryHandler(filter, QUERY_AVATAR, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: result, total } }) => {
        if (edit?.avatar_url) {
          const foundAvatar = result.find(
            (avatar) => avatar.url === edit.avatar_url
          );
          if (foundAvatar) {
            setSelectedAvatar(foundAvatar);
            form.setFieldsValue({
              avatar_id: foundAvatar.id,
            });
          }
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList();
    getAvatarDataList(pagin.page_number, pagin.per_page);
  }, []);

  const languageList = ["ENG", "MM"];

  const openDrawer = () => setShowForm(true);

  function avatarCloseDrawer(key) {
    setShowForm(false);
  }

  function handleAvatarSelect(val) {
    setSelectedAvatar(val);
    form.setFieldsValue({
      avatar_id: val.id,
    });
  }

  function handleBankTypeChange(value) {
    setSelectedBankType(value);

    if (value.endsWith("PAY")) {
      form.setFieldsValue({ acc_number: "+95" });
    } else {
      form.setFieldsValue({ acc_number: "" });
    }
  }

  function handleAccNumberChange(e) {
    const input = e.target.value;
    const prefix = "+95 ";

    if (selectedBankType.endsWith("PAY")) {
      if (!input.startsWith(prefix)) {
        return prefix + input.replace(/^\+95\s*/, "").replace(/[^\d]/g, "");
      }

      if (input.length < prefix.length) {
        return prefix;
      }

      const rest = input.slice(prefix.length).replace(/[^\d]/g, "");
      return prefix + rest;
    }

    return input.replace(/[^\d]/g, "");
  }
  function validateAccountNumber(_, value) {
    if (selectedBankType.endsWith("PAY")) {
      if (!value.startsWith("+95 ")) {
        return Promise.reject(new Error("Account number must start with +95"));
      }

      const digitsAfterPrefix = value.replace("+95 ", "").trim();
      if (!digitsAfterPrefix || digitsAfterPrefix.length === 0) {
        return Promise.reject(new Error("Please enter phone number after +95"));
      }
    }

    return Promise.resolve();
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };

  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 25, height: 25, marginRight: 8, borderRadius:"5px" }}
        />
        <span>{value.replace(/_/g, " ")}</span>
      </div>
    );
  }

  return (
    <>
      <Form
        size={ui_size}
        form={form}
        onFinish={submitHandler}
        initialValues={edit ? { ...edit, dob: dayjs(edit.dob) } : {}}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <FormInputItem
              label="Nick Name"
              name="nick_name"
              placeholder="Nick Name"
              icon={<UserOutlined />}
              rules={[{ required: true, message: "Name is required" }]}
            />
          </Col>
          <Col span={12}>
            <Form.Item
              label="Language"
              name="language"
              rules={[{ required: true, message: "Language is required" }]}
            >
              <Select
                placeholder={
                  <span>
                    <VerifiedOutlined style={{ marginRight: 8 }} />
                    Select Language
                  </span>
                }
                options={languageList.map((value) => ({
                  label: value,
                  value: value,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          {!edit && (
            <>
              <Col span={12}>
                <FormPasswordItem
                  label="Password"
                  name="password"
                  placeholder="Password"
                  icon={<KeyOutlined />}
                  rules={[
                    { required: true, message: "Please input your password!" },
                    { validator: validatePassword },
                  ]}
                  help={passwordError}
                  validateStatus={passwordError ? "warning" : ""}
                  hasFeedback
                />
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Bank Type"
                  name="bank_type"
                  rules={[{ required: true, message: "Bank type is required" }]}
                >
                  <Select
                    placeholder={
                      <span>
                        <BankOutlined style={{ marginRight: 8 }} />
                        Select Bank Type
                      </span>
                    }
                    options={bankList.map((value) => ({
                      label: renderBankOption(value),
                      value: value,
                    }))}
                    onChange={handleBankTypeChange}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
        {!edit && (
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <FormInputItem
                label="Account Name"
                name="acc_name"
                placeholder="Account Name"
                icon={<UserOutlined />}
                rules={[
                  { required: true, message: "Account Name is required" },
                ]}
              />
            </Col>
            <Col span={12}>
              <Form.Item
                label="Account No."
                name="acc_number"
                rules={[
                  { required: true },
                  { validator: validateAccountNumber },
                ]}
                getValueFromEvent={handleAccNumberChange}
              >
                <Input
                  prefix={
                    <FieldNumberOutlined style={{ marginRight: "8px" }} />
                  }
                  placeholder="Account Number"
                  style={{ width: "100%" }}
                  onKeyDown={(e) => {
                    const prefix = "+95 ";

                    if (
                      selectedBankType.endsWith("PAY") &&
                      ["Backspace", "Delete"].includes(e.key) &&
                      e.target.selectionStart <= prefix.length
                    ) {
                      e.preventDefault();
                    }

                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item
              label="Date Of Birth"
              name="dob"
              rules={[{ required: true, message: "Date of Birth is required" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder="Select birth date"
               
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <Form.Item
              label="Avatar"
              name="avatar_id"
              rules={[
                { required: !edit, message: "Avatar selection is required" },
              ]}
            >
              <Row gutter={16} align="middle">
                <Col>
                  <Button icon={<SmileOutlined />} onClick={openDrawer}>
                    {selectedAvatar || edit.avatar_url
                      ? "Change Avatar"
                      : "Select Avatar"}
                  </Button>
                </Col>
                {selectedAvatar && (
                  <Col>
                    <img
                      src={selectedAvatar.url}
                      alt="Selected Avatar"
                      style={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                      }}
                    />
                  </Col>
                )}
                {/* {!selectedAvatar && (
                  <Col>
                    <img
                      src={edit.avatar_url}
                      alt="Selected Avatar"
                      style={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                      }}
                    />
                  </Col>
                )} */}
              </Row>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} align="right">
            <Button type="primary" htmlType="submit" loading={loading}>
              {edit ? "Update" : "Create"}
            </Button>
            <Button
              onClick={() => closeDrawer(false)}
              style={{ marginLeft: "16px" }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
      <Drawer
        open={showForm}
        title="Select Avatar"
        destroyOnClose
        onClose={() => avatarCloseDrawer(false)}
        width={"1200px"}
      >
        <AvatarForm
          closeDrawer={avatarCloseDrawer}
          onSelect={handleAvatarSelect}
        />
      </Drawer>
    </>
  );
}
